import * as React from 'react';
import * as _ from 'lodash';
import { Portal } from 'react-portal';
import { FeatureRecordDownload } from './components';
import { DropZone } from './components';
import { Uploading } from './components';
import { FixDropZone } from './components';
import { WARNING_TYPES } from './index';
import { CategoriesOnlyCheckbox } from './components';
import { KitchenOrBathroomCheckboxes } from './components';
import { ToolSettingsTypeCheckboxes } from './components';
export default function () {
    function onClick1() {
        this.setState({ isVisible: false });
    }
    function onChange2(e) {
        this.setMasterFabricatorId(e);
    }
    function onClick3() {
        this.setState({ isVisible: false });
    }
    function onClick4() {
        this.next();
    }
    function onClick5() {
        this.backup();
    }
    return React.createElement('div', {
        'className': 'ui-button2 ui-button2--blue',
        'onClick': this.show
    }, '\r\n  Import Features\r\n  ', this.state.isVisible ? React.createElement(Portal, {
        'node': document && document.querySelector('.portal-target'),
        'key': '623'
    }, React.createElement('div', { 'className': 'ui-popup--overlay' }, React.createElement('div', { 'className': 'ui-popup ui-popup--large' }, React.createElement('div', { 'className': 'ui-popup-header' }, React.createElement('span', { 'className': 'ui-popup-header__text' }, 'Bulk Import Features'), React.createElement('div', {
        'className': 'ui-popup-header__close',
        'onClick': onClick1.bind(this)
    })), this.state.warningVisible ? React.createElement('div', {
        'className': 'ui-popup-header-warning',
        'key': '1063'
    }, React.createElement('h2', {}, 'WARNING!'), React.createElement('div', {}, '\r\n            You have selected to delete fields on the database that have been left empty in your CSV.\r\n          ')) : null, React.createElement('div', { 'className': 'ui-popup-body ui-popup-body--nopadding bulk-import-body ' + (this.state.warningVisible ? 'ui-popup-body--warning' : '') }, !this.state.warningVisible && !this.state.exportDialogVisible ? [
        React.createElement('div', {
            'className': 'bulk-import-half bulk-import-half--left',
            'key': '14681'
        }, React.createElement('p', {}, 'Here you can download a features backup as CSV by clicking ', React.createElement('strong', {}, '\'Download Latest Feature Records\''), ', or upload CSV to create and update features.'), React.createElement('div', { 'className': 'bulk-import-img--blue' }), React.createElement(FeatureRecordDownload, {
            'hasRecords': this.state.hasRecords,
            'showWarning': this.state.clearEmpty,
            'onClick': this.showExport
        })),
        React.createElement('div', {
            'className': 'bulk-import-half bulk-import-half--right',
            'key': '14683'
        }, !this.state.pending && !this.state.validationData ? React.createElement(DropZone, {
            'parent': this,
            '{...this.props}': true,
            'key': '2116'
        }) : null, this.state.pending ? React.createElement(Uploading, {
            '{...this.props}': true,
            'key': '2232'
        }) : null, !this.state.pending && this.state.validationData ? React.createElement(FixDropZone, {
            'parent': this,
            '{...this.props}': true,
            'csv': this.ImportFeatures.getData(),
            'key': '2304'
        }) : null)
    ] : null, this.state.warningVisible ? React.createElement('div', {
        'className': 'bulk-import-warning',
        'key': '2499'
    }, this.state.warningType == WARNING_TYPES.Save ? React.createElement('div', {
        'className': 'bulk-import-warning-icon bulk-import-warning-icon--warning',
        'key': '2584'
    }, React.createElement('div', {}, React.createElement('input', {
        'type': 'number',
        'className': 'ui-input ui-input--gray2 ui-input-block__input',
        'placeholder': 'Master Fabricator Id',
        'onChange': onChange2.bind(this),
        'style': {
            border: '1px solid gray!important',
            color: 'black'
        }
    })), React.createElement('h2', {}, 'IMPORTANT!'), '\r\n              Are you sure you wish to save? All empty feature fields in your CSV file will delete those specific features in the system database. Make sure you have a backup before proceeding.\r\n            ') : null, this.state.warningType == WARNING_TYPES.Backup ? React.createElement('div', {
        'className': 'bulk-import-warning-icon bulk-import-warning-icon--warning',
        'key': '3256'
    }, React.createElement('h2', {}, 'IMPORTANT!'), '\r\n              Before you can proceed, a backup of your current features is required. Click "backup" to download. Make sure to save this backup in a place that you can easily reference and restore if needed.\r\n            ') : null) : null, this.state.exportDialogVisible ? React.createElement('div', {
        'className': 'bulk-import-warning',
        'key': '3680'
    }, React.createElement('h2', {}, 'Backup Options'), React.createElement('h3', {}, 'Categories'), React.createElement(CategoriesOnlyCheckbox, {
        'parent': this,
        '{...this.props}': true
    }), React.createElement('h3', {}, 'Tools'), React.createElement(KitchenOrBathroomCheckboxes, {
        'parent': this,
        '{...this.props}': true
    }), React.createElement('h3', {}, 'Types'), React.createElement(ToolSettingsTypeCheckboxes, {
        'parent': this,
        '{...this.props}': true
    })) : null), React.createElement('div', { 'className': 'ui-popup-footer' }, React.createElement('button', { 'className': 'ui-button ui-button--blue' }, React.createElement('span', {
        'className': 'ui-button-text ui-button--uppercase',
        'onClick': onClick3.bind(this)
    }, 'CANCEL')), this.state.nextVisible ? React.createElement('button', {
        'className': 'ui-button ui-button--large ' + (this.state.nextEnabled ? 'ui-button--green' : 'ui-button--gray disabled'),
        'key': '4388'
    }, React.createElement('span', {
        'className': 'ui-button-text ui-button--uppercase',
        'onClick': onClick4.bind(this)
    }, this.state.warningVisible ? 'SAVE' : 'NEXT')) : null, this.state.backupVisible ? React.createElement('button', {
        'className': 'ui-button ui-button--large ' + (this.state.backupEnabled ? 'ui-button--red' : 'ui-button--gray disabled'),
        'key': '4721'
    }, React.createElement('span', {
        'className': 'ui-button-text ui-button--uppercase',
        'onClick': onClick5.bind(this)
    }, 'BACKUP')) : null)))) : null);
}